"use strict";

exports.__esModule = true;
exports["default"] = hideText;

function hideText() {
  return {
    textIndent: '101%',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
  };
}

module.exports = exports.default;